var _circle, _g, _circle2, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNocYellowMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 90,
    viewBox: "0 0 76 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 38,
    cy: 52,
    r: 38,
    fill: "#2FAAF1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_80602_61441)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 52,
    r: 12,
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 52,
    r: 7.5,
    fill: "#2FAAF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80602_61441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 57,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 56,
    width: 56,
    height: 56,
    transform: "rotate(-90 10.5 56)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80602_61441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 18.6671C52.5 22.1671 51.3917 25.2101 49.175 27.7962C46.9583 30.3823 44.1778 31.9476 40.8333 32.4921L40.8333 49.0004C40.8333 49.6615 40.6097 50.2157 40.1625 50.6629C39.7153 51.1101 39.1611 51.3337 38.5 51.3337C37.8389 51.3337 37.2847 51.1101 36.8375 50.6629C36.3903 50.2157 36.1667 49.6615 36.1667 49.0004L36.1667 32.4921C32.8222 31.9476 30.0417 30.3823 27.825 27.7962C25.6083 25.2101 24.5 22.1671 24.5 18.6671C24.5 14.7782 25.8611 11.4726 28.5833 8.7504C31.3056 6.02818 34.6111 4.66707 38.5 4.66707C42.3889 4.66707 45.6944 6.02818 48.4167 8.7504C51.1389 11.4726 52.5 14.7782 52.5 18.6671Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.4996,
    cy: 18.6671,
    r: 8.33333,
    fill: "#FBA842",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_80602_61441",
    x: 22,
    y: 40,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80602_61441"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80602_61441",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocYellowMarker);
export default __webpack_public_path__ + "static/media/noc-yellow-marker.d37629289ed3f2688011563f72bcaaf8.svg";
export { ForwardRef as ReactComponent };